import z from 'zod'
import { decimalSchema } from '../../utils/schema'

const depositHistorySchema = z.object({
  /** deposit amount */
  amount: decimalSchema,
  /** coin */
  coin: z.string(),
  /** deposit network */
  network: z.string(),
  /** deposit status, 1:SMALL, 2:TIME_DELAY, 3:LARGE_DELAY, 4:PENDING, 5:SUCCESS, 6:AUDITING, 7:REJECTED, 8:REFUND, 9:PRE_SUCCESS, 10:INVALID, 11:RESTRICTED, 12:COMPLETED */
  status: z.number().int(),
  /** deposit address */
  address: z.string(),
  /** addressTag */
  addressTag: z.string().optional(),
  /** txId */
  txId: z.string(),
  /** insertTime (timestamp) */
  insertTime: z.number().int(),
  /** unlockConfirm */
  unlockConfirm: z.string(),
  /** confirmTimes */
  confirmTimes: z.string(),
  /** memo */
  memo: z.string().nullable(),
})

export const responseSchema = z.array(depositHistorySchema)
